import React from 'react';
import PropTypes from 'prop-types';
import { PageHeaderStyle } from './style';
import { Breadcrumb } from 'antd';
import FeatherIcon from 'feather-icons-react';

const PageHeader = (props) => {
    const { title, subTitle, routes, buttons, ghost, bgColor, className } = props;
    return (
        <>
            <div
                style={{
                    backgroundColor: bgColor || '#F4F5F7',
                }}
            >
                <PageHeaderStyle
                    style={{
                        backgroundColor: 'rgb(244, 245, 247)',
                    }}
                    // onBack={() => window.history.back()}
                    breadcrumbRender={(props) => {
                        const { breadcrumb } = props;
                        return (
                            breadcrumb &&
                            breadcrumb.routes &&
                            breadcrumb.routes.length > 0 && (
                                <Breadcrumb separator={<FeatherIcon icon="chevron-right" size={14} />}>
                                    {breadcrumb.routes.map((route, i) => {
                                        return (
                                            <Breadcrumb.Item key={route.path || route.breadcrumbName || i} href={route.path || '#'}>
                                                {route.icon && <FeatherIcon icon={route.icon} size={14} />}
                                                {route.breadcrumbName ? <span>{route.breadcrumbName}</span> : null}
                                            </Breadcrumb.Item>
                                        );
                                    })}
                                </Breadcrumb>
                            )
                        );
                    }}
                    className={className}
                    title={title}
                    subTitle={subTitle}
                    breadcrumb={routes && { routes }}
                    extra={buttons}
                    ghost={ghost}
                />
            </div>
        </>
    );
};

PageHeader.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    bgColor: PropTypes.string,
    className: PropTypes.string,
    routes: PropTypes.arrayOf(PropTypes.object),
    // eslint-disable-next-line react/forbid-prop-types
    buttons: PropTypes.array,
    ghost: PropTypes.bool,
};

export { PageHeader };
